"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPixel = void 0;
/*
 * This function is used to get the pixel value from the string
 * and it fires the impression URL on load.
 */
const createPixel = (src) => {
    if (!src)
        return;
    const img = new Image();
    img.setAttribute('src', src);
};
exports.createPixel = createPixel;
//# sourceMappingURL=pixel.util.js.map